import { TemplateWorkgroupsTable } from './TemplateWorkgroupsTable';
import { useGetTemplateWorkgroupsQuery } from '@api/survey-templates';
import { SurveyTemplateMinData } from '../../types';
import { DelegateTemplateWorkgroupBtn } from './DelegateTemplateWorkgroupBtn';
import { useAppSelector } from '@reducers/index';
import { getRootConfig } from '@selectors/globalData';
import { FeaturePermissions } from '@services/permissions/FeaturePermissions';
import { UpgradeRequired } from '@routes/upgrade-required';
import { MetricGroup } from '@g17eco/types/metricGroup';
import { Loader } from '@g17eco/atoms/loader';

interface Props {
  template: SurveyTemplateMinData;
  metricGroups: MetricGroup[];
}

export const TemplateWorkgroupsView = ({ template, metricGroups }: Props) => {
  const rootConfig = useAppSelector(getRootConfig);
  const workgroupsLimit = FeaturePermissions.getLimitWorkgroups(rootConfig);
  const { data: workgroups = [], isLoading } = useGetTemplateWorkgroupsQuery(template._id, {
    skip: workgroupsLimit === 0,
  });

  if (workgroupsLimit === 0) {
    return <UpgradeRequired />;
  }

  if (isLoading) {
    return <Loader relative />;
  }

  return (
    <>
      <div className='d-flex align-items-center mt-3'>
        <DelegateTemplateWorkgroupBtn
          template={template}
          metricGroups={metricGroups}
          delegatedWorkgroups={workgroups}
        />
      </div>
      <TemplateWorkgroupsTable template={template} workgroups={workgroups} metricGroups={metricGroups} />
    </>
  );
};
